/* @flow */
import { DefaultTheme, Provider as PaperProvider } from 'react-native-paper';
import React from 'react';
import color from 'color';

import { useTheme } from './theme';


const getTheme = (baseTheme) => ({
  ...DefaultTheme,
  dark: baseTheme.isDark,
  roundness: 4,
  colors: {
    ...DefaultTheme.colors,
    primary: baseTheme.colors.primary,
    accent: baseTheme.colors.secondary,
    background: baseTheme.colors.background,
    error: baseTheme.colors.delete,
    text: baseTheme.colors.text,
    surface: baseTheme.colors.surface,
    disabled: color('black')
      .alpha(0.26)
      .rgb()
      .string(),
    placeholder: color('black')
      .alpha(0.54)
      .rgb()
      .string(),
    backdrop: color('black')
      .alpha(0.5)
      .rgb()
      .string(),
    notification: baseTheme.colors.delete,
  },
  fonts: {
    ...DefaultTheme.fonts,
  },
});

export const Provider = ({ children }) => {
  const baseTheme = useTheme();

  return (
    <PaperProvider theme={getTheme(baseTheme)}>
      {children}
    </PaperProvider>

  );
};

export default { Provider };
